import { render, staticRenderFns } from "./ModalDeleteCp.vue?vue&type=template&id=64948b1a&scoped=true"
import script from "./ModalDeleteCp.vue?vue&type=script&lang=js"
export * from "./ModalDeleteCp.vue?vue&type=script&lang=js"
import style0 from "./ModalDeleteCp.vue?vue&type=style&index=0&id=64948b1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64948b1a",
  null
  
)

export default component.exports